import type { ReactNode } from 'react';
import styles from './ui.module.css';

/**
 * Сетка плиток в две колонки: реестр и база внешек.
 *
 * Свой grid вместо вкуишного SimpleGrid, потому что тот раскладывает флексом,
 * и соседние плитки в строке живут каждая своей высотой — проверено в
 * браузере: при длинном имени в одной колонке вторая строка съезжала на
 * десять пикселей. В макетах это ровная сетка, и карточки в строке одной
 * высоты. Здесь это даёт grid и align-items: stretch по умолчанию.
 */
export function TileGrid({ children }: { children: ReactNode }) {
  return <div className={styles.tileGrid}>{children}</div>;
}
